(function() {

  function initInfiniteScroll() {
    const sentinel = document.getElementById("infinite-scroll-sentinel");
    const grid = document.querySelector(".collection__grid");
    if (!sentinel || !grid) return;

    if (sentinel.getAttribute("data-infinite-scroll-init") === "true") return;
    sentinel.setAttribute("data-infinite-scroll-init", "true");

    let nextUrl = sentinel.getAttribute("data-next-url");
    if (!nextUrl) return;

    const pagination = document.querySelector(".pagination");
    if (pagination) pagination.style.display = "none";

    const observer = new IntersectionObserver(async (entries) => {
      nextUrl = sentinel.getAttribute("data-next-url");

      if (entries[0].isIntersecting && nextUrl) {
        sentinel.classList.add("loading");
        observer.unobserve(sentinel);

        try {
          const response = await fetch(nextUrl);
          const text = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");

          const newProducts = doc.querySelectorAll(".collection__grid .grid__item");

          if (newProducts.length > 0) {
            newProducts.forEach((product) => {
              product.classList.remove("animate", "animate-up");
              product.style.opacity = "0";
              product.style.transform = "translateY(20px)";
              product.style.transition = "opacity 0.5s ease, transform 0.5s ease";
              grid.appendChild(product);

              setTimeout(() => {
                product.style.opacity = "1";
                product.style.transform = "translateY(0)";
              }, 50);
            });

            window.dispatchEvent(new Event('resize'));
          }

          const nextLink = doc.querySelector('[data-pagination="next"]');
          if (nextLink) {
            nextUrl = nextLink.href;
            sentinel.setAttribute("data-next-url", nextUrl);
            observer.observe(sentinel);
          } else {
            nextUrl = null;
            sentinel.removeAttribute("data-next-url");
            sentinel.style.display = 'none';
          }

        } catch (err) {
          console.error("Infinite scroll error:", err);
        } finally {
          sentinel.classList.remove("loading");
        }
      }
    }, { rootMargin: "400px" });

    observer.observe(sentinel);
  }

  /* =========================================
     MEGA MENU HOVER LOGIC (ADDED SAFELY)
  ========================================== */

  function initMegaMenuHover() {
  // Desktop only
  if (window.innerWidth < 1024) return;

  const items = document.querySelectorAll('.header__links-list > li');

  items.forEach(li => {
    // only bind once
    if (li.getAttribute('data-mega-hover-init') === 'true') return;
    li.setAttribute('data-mega-hover-init', 'true');

    const link = li.querySelector(':scope > a[data-mega]');
    const mega = li.querySelector(':scope > nav.mega-nav');

    // Only apply to items that actually have mega nav
    if (!link || !mega) return;

    let closeTimer;

    const open = () => {
      clearTimeout(closeTimer);

      // Close any other open mega menus
      document.querySelectorAll('.header__links-list > li.is-mega-open')
        .forEach(openLi => {
            if (openLi !== li) openLi.classList.remove('is-mega-open');
            const a = openLi.querySelector(':scope > a[data-mega]');
            if (a) a.setAttribute('aria-expanded', 'false');
          });

        // Open this one
        li.classList.add('is-mega-open');

        // Add common “open” attributes (safe even if theme doesn’t use them)
        link.setAttribute('aria-expanded', 'true');
        mega.setAttribute('aria-hidden', 'false');
        mega.setAttribute('data-open', 'true');
      };

      const close = () => {
        li.classList.remove('is-mega-open');
        link.setAttribute('aria-expanded', 'false');
        mega.setAttribute('aria-hidden', 'true');
        mega.removeAttribute('data-open');
      };

      li.addEventListener('mouseenter', open);

      li.addEventListener('mouseleave', () => {
        // small delay helps prevent accidental close
        closeTimer = setTimeout(close, 150);
      });

      // optional: keep open when hovering mega area
      mega.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      mega.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(close, 150);
      });
    });
  }

  /* ========================================= */

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initInfiniteScroll();
      initMegaMenuHover();   // initialize here
    });
  } else {
    initInfiniteScroll();
    initMegaMenuHover();     // initialize here
  }

  const container = document.querySelector("[data-js-partial]");
  if (container) {
    const mutationObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          initInfiniteScroll();
          initMegaMenuHover(); // re-bind after ajax updates
          break;
        }
      }
    });
    mutationObserver.observe(container, { childList: true, subtree: true });
  }

})();